import {Component, HostListener, Inject, Input, PLATFORM_ID} from '@angular/core';
import {TranslocoService} from "@ngneat/transloco";
import {Lookups} from "@model";
import {isPlatformBrowser} from "@angular/common";

@Component({
    selector: 'app-info-section-public',
    templateUrl: './info-section-public.component.html',
    styleUrls: ['./info-section-public.component.scss'],
    standalone: false
})
export class InfoSectionPublicComponent {
  @Input({required: true}) currentItem: any;
  @Input() showBreadcrumbs: boolean = true;
  @Input() showTrailingLocation: boolean = true;
  @Input({required: true}) languages: Lookups[] = [];
  @Input({required: true}) currentItemType: CurrentItemType = CurrentItemType.EVENT;

  public currentWindowWidth: number = 0;

  constructor(
    public translocoService: TranslocoService, @Inject(PLATFORM_ID) private platformId: Object) {
    if (isPlatformBrowser(this.platformId)) {
      this.currentWindowWidth = window.innerWidth;
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.currentWindowWidth = event.target.innerWidth;
  }

  onOpenLocation() {
    if (this.currentItem.latitude && this.currentItem.longitude) {
      if ((navigator.platform.indexOf("iPhone") != -1)
        || (navigator.platform.indexOf("iPod") != -1)
        || (navigator.platform.indexOf("iPad") != -1)) {
        window.open(`maps://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination=${this.currentItem.latitude},${this.currentItem.longitude}`);
      } else {
        window.open(`https://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination=${this.currentItem.latitude},${this.currentItem.longitude}`);
      }
    }
  }

  protected readonly CurrentItemType = CurrentItemType;
}

export enum CurrentItemType {
  EVENT = 0,
  LEAGUE = 1
}
